import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SelectPayment.module.scss';
import WebPay from "../payment-types/WebPay";
import {Modal} from "presentation/common";
import BillDetail from "../bill-info/bill-detail/BillDetail";
import BillInfoForm from "../bill-info-form/BillInfoForm";
import {emptyFn} from "presentation/common/helpers/utils";

export const SelectPayment = props => {
  const modalRef = React.useRef();
  const {billInfo, onEditBillInfo, onRemoveBillInfo, onEditPaymentType, paymentType} = props;
  const showBillDetail = billInfo && billInfo.rut;

  const openModal = useCallback(() => {
    modalRef.current.open();
  }, []);

  const closeModal = useCallback(() => {
    modalRef.current.close();
  }, []);

  const setBillInfo = (formData) => {
    closeModal();
    onEditBillInfo(formData);
  };

  const onUpdatePaymentType = (event) => {
    onEditPaymentType(event.currentTarget.value);
  };

  return (
    <div className="flex flex-col flex-auto">
      {
        showBillDetail
          ? <BillDetail onEdit={openModal} billInfo={billInfo} onRemove={onRemoveBillInfo}/>
          :
          <span className={clsx(styles.billMessage, "pt-sm mx-sm")} onClick={openModal}>¿Deseas recibir factura?</span>
      }

      <WebPay onChange={onUpdatePaymentType} paymentType={paymentType}/>
      {/*<Transfer onChange={onUpdatePaymentType} paymentType={paymentType}/>*/}
      {/*<BankKhiku onChange={onUpdatePaymentType} paymentType={paymentType}/>*/}

      <Modal ref={modalRef} title="Datos de Facturación">
        <BillInfoForm onCancelAction={closeModal} onSubmitAction={setBillInfo} billInfo={billInfo}/>
      </Modal>
    </div>
  );
};

SelectPayment.propTypes = {
  onEditPaymentType: PropTypes.func,
  onEditBillInfo: PropTypes.func,
  onRemoveBillInfo: PropTypes.func,
  billInfo: PropTypes.object,
  paymentType: PropTypes.string
};

SelectPayment.defaultProps = {
  onEditPaymentType: emptyFn,
  onEditBillInfo: emptyFn,
  onRemoveBillInfo: emptyFn,
  billInfo: {}
};

export default SelectPayment;
